<div class="container d-flex align-items-center justify-content-center">
  <div class="col-md-10 col-lg-8 col-xl-6 p-0">
    <div class="card">
      <div class="card-header">
        <picture>
          <source
            srcset="/resources/images/finquery-logo-white.png"
            media="(min-width: 900px)"
          />
          <img
            src="/resources/images/finquery-logo-white.png"
            alt="FinQuery"
            class="icon-banner"
            height="32"
          />
        </picture>
      </div>
      @if (isLoaded) {
        <div>
          <form [formGroup]="form" (validSubmit)="onConnectClick()">
            <div class="card-body">
              <h3>
                Let's get you set up to use Microsoft Dynamics Business Central
              </h3>
              <p class="card-text">
                Select the environment to use with FinQuery Fixed Assets.
              </p>
              <div class="mb-3">
                <label for="environmentName"
                  ><strong>Select an environment</strong></label
                >
                <select
                  data-dd-action-name="dynamics-select-environment.environment-select"
                  (change)="onEnvironmentSelected()"
                  class="form-select"
                  id="environmentName"
                  [class.is-invalid]="
                    form.controls.environmentName.touched &&
                    form.controls.environmentName.invalid
                  "
                  formControlName="environmentName"
                >
                  <option value="">&ndash;</option>
                  @for (environment of environments; track environment) {
                    <option [value]="environment.name">
                      {{ environment.name }}
                    </option>
                  }
                </select>
              </div>

              @if (form.controls.environmentName.value) {
                <div class="mb-3">
                  <label for="companyId"
                    ><strong>Select a company</strong></label
                  >
                  <div class="input-group mb-3">
                    <select
                      data-dd-action-name="dynamics-select-environment.company-select"
                      class="form-select"
                      id="companyId"
                      [class.is-invalid]="
                        form.controls.companyId.touched &&
                        form.controls.companyId.invalid
                      "
                      formControlName="companyId"
                    >
                      <option value="">&ndash;</option>
                      @for (company of companies; track company) {
                        <option [value]="company.id">
                          {{ companyLabel(company) }}
                        </option>
                      }
                    </select>
                    @if (isLoadingCompanies) {
                      <div class="input-group-text">
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </div>
                    }
                  </div>
                </div>
              }

              @if (isNewConnection) {
                <app-select-integration-register [formGroup]="form">
                </app-select-integration-register>
              }
            </div>
            <div class="card-footer">
              <div class="d-flex justify-content-between">
                <button
                  data-dd-action-name="dynamics-select-environment.cancel-button"
                  type="button"
                  class="btn btn-outline text-start"
                  [disabled]="form.disabled"
                  (click)="onCancelClick()"
                >
                  Cancel
                </button>
                @if (!isConnecting) {
                  <button
                    data-dd-action-name="dynamics-select-environment.connect-button"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Connect
                  </button>
                } @else {
                  <button
                    data-dd-action-name="dynamics-select-environment.connect-loading-button"
                    class="btn btn-primary"
                    type="button"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Connecting&hellip;
                  </button>
                }
              </div>

              <hr />
              <div class="text-sm mt-3">
                &copy; {{ currentYear }} FinQuery, LLC
              </div>
            </div>
          </form>
        </div>
      } @else {
        <app-loading></app-loading>
      }
    </div>
  </div>
</div>
